import * as React from 'react'

function BankCardIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={19} height={15} viewBox="0 0 19 15" {...props}>
      <g data-name="Group 52579">
        <g data-name="Group 9109" fill="none" stroke="CurrentColor" strokeWidth={1.5}>
          <g
            data-name="Rectangle 3284"
            transform="translate(-24.5 -265) translate(1697.5 -15037.431) translate(-1673 15302.431)"
          >
            <path stroke="none" d="M0 0H19V15H0z" />
            <path d="M0.75 0.75H18.25V14.25H0.75z" />
          </g>
          <path
            data-name="Path 13395"
            d="M-1655.187 15307.45h-16.749"
            strokeLinejoin="round"
            transform="translate(-24.5 -265) translate(1697.5 -15037.431)"
          />
          <path
            data-name="Path 17337"
            d="M-1666.335 15312.641h-3.739"
            strokeLinejoin="round"
            transform="translate(-24.5 -265) translate(1697.5 -15037.431)"
          />
        </g>
      </g>
    </svg>
  )
}

export default BankCardIcon
